// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure--figure--2YNfK","background":"Figure--background--czI_j"};